import { env } from '@/lib/env';

type Action = 'login' | 'register' | 'forgot_password' | 'resend_code' | 'checkout' | 'feedback';

interface Grecaptcha {
  ready(cb: () => void): void;
  execute(siteKey: string, opts: { action: string }): Promise<string>;
}

let loader: Promise<Grecaptcha> | null = null;

function load(): Promise<Grecaptcha> {
  loader ??= new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(env.recaptchaSiteKey)}`;
    script.async = true;
    script.onload = () => {
      const g = (window as unknown as { grecaptcha: Grecaptcha }).grecaptcha;
      g.ready(() => resolve(g));
    };
    script.onerror = () => reject(new Error('No se pudo cargar reCAPTCHA'));
    document.head.appendChild(script);
  });
  return loader;
}

/**
 * Token de reCAPTCHA v3 justo antes de enviar (plan §6.7). Sin llave pública (local) devuelve
 * undefined y la API corre con RECAPTCHA_BYPASS.
 */
export async function recaptchaToken(action: Action): Promise<string | undefined> {
  if (!env.recaptchaSiteKey) return undefined;
  const g = await load();
  return g.execute(env.recaptchaSiteKey, { action });
}

export const recaptchaHeader = (token: string | undefined) =>
  token ? { 'X-Recaptcha-Token': token } : {};
